import installationInstructions from './installationInstructions';

const lightStripCategoryContent = {
  installationInstructions
}

export { lightStripCategoryContent };
